<template>
    <div class="history">
        <el-dialog title="申请记录" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
            <div class="table scroll-auto" v-loading="load">
                <el-table :data="classTable" style="width: 100%" border>
                    <el-table-column width="180px" align="center" prop="level[0].top_name" show-overflow-tooltip label="一级类目"> </el-table-column>
                    <el-table-column width="180px" align="center" prop="level[0].parent_name" show-overflow-tooltip label="二级类目"> </el-table-column>
                    <el-table-column width="180px" align="center" prop="level[0].name" show-overflow-tooltip label="三级类目"> </el-table-column>
                    <el-table-column width="140px" align="center" prop="level[0].deposit" label="类目押金 (元)"> </el-table-column>
                    <el-table-column width="140px" align="center" prop="amount" label="支付金额"> </el-table-column>
                    <el-table-column width="140px" align="center" prop="audit_status" label="类目状态">
                        <template slot-scope="{ row }">
                            <span :class="row.audit_status == 3 ? 'red' : ''"> {{ row.audit_status == 1 ? "待审核" : row.audit_status == 2 ? "审核通过" : "审核拒绝" }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="180px" align="center" prop="create_time" label="申请时间" show-overflow-tooltip> </el-table-column>
                    <el-table-column width="180px" align="center" prop="audit_time" label="审核时间" show-overflow-tooltip> </el-table-column>
                    <el-table-column width="180px" align="center" prop="address" label="操作" fixed="right">
                        <template slot-scope="{ row }">
                            <div class="link">
                                <el-link type="primary" v-if="row.audit_status == 3">重新申请</el-link>
                                <el-link type="primary" v-if="row.tread_status == 1&&row.audit_status == 2" @click="payShow(row)">待支付</el-link>
                                <span v-if="row.tread_status == 2&&row.audit_status==2">已支付</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            classTable: [],
            dialogVisible: false,
            load: false,
        };
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    methods: {
        ...mapActions({
            categoryHistory: "detect/categoryHistory",
        }),
        payShow(row) {
            this.$emit("payShow", JSON.parse(JSON.stringify(row)));
        },
        handleClose() {
            this.dialogVisible = false;
        },
        getCategoryList(id) {
            this.load = true;
            let params = {
                token: this.getToken,
                shop_id: id,
            };
            this.categoryHistory(params).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.classTable = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.history {
    .table {
        height: 450px;
    }
    .link {
        a {
            margin: 0 8px;
        }
    }
}
.red {
    color: #fb7369;
}
</style>